import { injectable } from 'inversify';

import ILocalizationService from './i-localization-service';
import LocalizationChangedEventArgs from './localization-changed-event-args';
import { Localization } from './localization';
import LocalizationStaticDictionary from './localization-static-dictionary';

import { WpEvent, WpEventHandler, ActionResult, ErrorTypes } from './../Common';
import ITranslatable from './i-translatable';
import { BaseSystemLocalizationDictionary } from '.';

@injectable()
export default class DefaultLocalizationService implements ILocalizationService {
    private _currentLocalization: Localization = Localization.RU;
    private _ruStaticDictionaries: Array<any> = [];
    private _enStaticDictionaries: Array<any> = [];

    private _localizationChanged: WpEventHandler<LocalizationChangedEventArgs> =
        new WpEventHandler<LocalizationChangedEventArgs>();

    get CurrentLocalization(): Localization {
        return this._currentLocalization;
    }

    get LocalizationChanged(): WpEvent<LocalizationChangedEventArgs> {
        return this._localizationChanged;
    }

    constructor() {

    }
    AddDictionary<T extends BaseSystemLocalizationDictionary>(localization: Localization, dictionary: LocalizationStaticDictionary<T>): void {
        if (localization == Localization.EN)
            this._enStaticDictionaries.push(dictionary);
        else
            this._ruStaticDictionaries.push(dictionary);
    }

    GetStaticDictionary<T extends BaseSystemLocalizationDictionary>(prefix: symbol): ActionResult<LocalizationStaticDictionary<T>> {
        let result: LocalizationStaticDictionary<T>;
        if (this.CurrentLocalization == Localization.EN) {
            result = this._enStaticDictionaries.find(x => x.Prefix == prefix) as LocalizationStaticDictionary<T>;
        } else {
            result = this._ruStaticDictionaries.find(x => x.Prefix == prefix) as LocalizationStaticDictionary<T>;
        }

        if (result == null)
            return ActionResult.FailedData(ErrorTypes.InternalError, result);

        return ActionResult.SuccessData(result);
    }
    
    async TranslateAsync(entity: ITranslatable): Promise<void> {
        throw new Error("Method not implemented.");
    }
    async TranslateManyAsync(entities: Array<ITranslatable>): Promise<void>{
        throw new Error("Method not implemented.");
    }

    async ChangeLocalizationAsync(localization: Localization): Promise<void> {
        this._localizationChanged.Send(this, { OldLocalization: Localization.RU, NewLocalization: Localization.EN });
    }


}
   